import { Component, OnInit } from "@angular/core";
import { SnackbarService } from "../../services/snackbar.service";

@Component({
  selector: 'app-auth-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  public openHelpDialog: boolean = false;
  public year: number = new Date().getFullYear();


  constructor(
    protected snackbarService: SnackbarService,
  ) {}

  ngOnInit() {
    this.setLightTheme();
  }
  
  setLightTheme() {
    document.body.classList.remove('dark');
    document.body.classList.add('light');
  }

  openHelpModal = () => {
    this.openHelpDialog = true;
  }
}